import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './StructureLogHeader.styles';
import SchemaIcon from '@mui/icons-material/Schema';

export default function StructureLogHeader({
  title = 'Structure Logs',
  onSearch,
  searchQuery,
  setSearchQuery,
}) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <SchemaIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>

      <SearchInput
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={onSearch}
      />
    </Box>
  );
}
